const baseEnvironment = process.env.REACT_APP_API_BASE_URL?.trim() || 'http://localhost:8010';
const API_BASE = baseEnvironment.replace(/\/$/, '');

const buildHeaders = () => {
  const token = sessionStorage.getItem('authToken');
  const headers = { 'Content-Type': 'application/json' };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
};

const handleErrors = async (response, defaultMessage) => {
  if (response.ok) {
    if (response.status === 204) {
      return null;
    }
    const text = await response.text();
    if (!text || !text.trim()) {
      return null;
    }
    try {
      return JSON.parse(text);
    } catch {
      return text;
    }
  }
  const rawText = await response.text().catch(() => '');
  let body = {};
  if (rawText && rawText.trim()) {
    try {
      body = JSON.parse(rawText);
    } catch {
      body = { message: rawText.trim() };
    }
  }
  throw new Error(
    body.detail
      || body.message
      || body.error
      || body.title
      || defaultMessage
      || `Request failed (${response.status})`
  );
};

export async function fetchMacroModules(companyId, periodId) {
  const params = new URLSearchParams({
    companyId: String(companyId),
    periodId: String(periodId)
  });
  const response = await fetch(`${API_BASE}/api/analysis/macro-data/modules?${params.toString()}`, {
    headers: buildHeaders()
  });
  return handleErrors(response, 'Makro moduller alinamadi.');
}

export async function fetchMacroSeries(companyId, periodId, instrument, limit = 36) {
  const params = new URLSearchParams({
    companyId: String(companyId),
    periodId: String(periodId),
    instrument: String(instrument),
    limit: String(limit)
  });
  const response = await fetch(`${API_BASE}/api/analysis/macro-data/series?${params.toString()}`, {
    headers: buildHeaders()
  });
  return handleErrors(response, 'Makro zaman serisi alinamadi.');
}

export async function refreshMacroData(companyId, periodId) {
  const params = new URLSearchParams({
    companyId: String(companyId),
    periodId: String(periodId)
  });
  const response = await fetch(`${API_BASE}/api/analysis/macro-data/refresh?${params.toString()}`, {
    method: 'POST',
    headers: buildHeaders()
  });
  return handleErrors(response, 'Makro veri yenilenemedi.');
}

export async function fetchMacroFxSeries(
  companyId,
  periodId,
  {
    instruments = ['USDTRY', 'EURTRY'],
    reportType = 'FOREX_BUY',
    startDate,
    endDate,
    frequency,
    formula,
    aggregationType
  }
) {
  const params = new URLSearchParams({
    companyId: String(companyId),
    periodId: String(periodId),
    reportType: String(reportType),
    startDate: String(startDate),
    endDate: String(endDate)
  });
  instruments.forEach((item) => params.append('instruments', String(item)));
  if (frequency !== undefined && frequency !== null && frequency !== '') {
    params.append('frequency', String(frequency));
  }
  if (formula !== undefined && formula !== null && formula !== '') {
    params.append('formula', String(formula));
  }
  if (aggregationType) {
    params.append('aggregationType', String(aggregationType));
  }

  const response = await fetch(`${API_BASE}/api/analysis/macro-data/fx-series?${params.toString()}`, {
    headers: buildHeaders()
  });
  return handleErrors(response, 'Doviz zaman serisi alinamadi.');
}

export async function fetchMacroInstrumentSeries(
  companyId,
  periodId,
  {
    instruments = [],
    startDate,
    endDate,
    frequency,
    formula,
    aggregationType,
    title
  }
) {
  const params = new URLSearchParams({
    companyId: String(companyId),
    periodId: String(periodId),
    startDate: String(startDate),
    endDate: String(endDate)
  });
  instruments.forEach((item) => params.append('instruments', String(item)));
  if (frequency !== undefined && frequency !== null && frequency !== '') {
    params.append('frequency', String(frequency));
  }
  if (formula !== undefined && formula !== null && formula !== '') {
    params.append('formula', String(formula));
  }
  if (aggregationType) {
    params.append('aggregationType', String(aggregationType));
  }
  if (title) {
    params.append('title', String(title));
  }

  const response = await fetch(`${API_BASE}/api/analysis/macro-data/instrument-series?${params.toString()}`, {
    headers: buildHeaders()
  });
  return handleErrors(response, 'Makro zaman serisi alinamadi.');
}

const macroDataService = {
  fetchMacroModules,
  fetchMacroSeries,
  refreshMacroData,
  fetchMacroFxSeries,
  fetchMacroInstrumentSeries
};

export default macroDataService;
